import PropTypes from "prop-types";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import "../../../../styles/ClientStyles.scss";
import STSComponent from "../../../STSComponent/STSComponent";
import HeaderIcons from "./components/HeaderIcons";
import "./css/ClientHeader.scss";
import StatescapeLogo2 from "../../../../images/statescape-logo2.png";
import { globals } from '../../../../globals';

class RedirectStateScapeLegacyLogout extends STSComponent {
  componentDidMount() {
    window.location.href = globals.servicesUrl + "/search/logoff.aspx";
  }
  render() {
    return null;
  }
}

class ClientHeader extends STSComponent {
  constructor (props) {
    super(props)
    this.state = {
      shutdown: false,
    }
  } 

  signOutLegacy = () => {
    localStorage.removeItem('authData')
    this.setState({ shutdown: true });
  }


  ClientBanner(authData) {
    let CustomBanner = authData.CustomBanner
    if (CustomBanner) {
      return <div className="container-fluid" style={ { backgroundColor: "#fff", textAlign: "center" } }>
          <a
            className="client-header-logo"
            href={authData.ClientWebsiteUrl}
            target="_blank"
            rel="noreferrer noopener"
          >
            <img src={authData.WebSiteBannerImage} alt="logo" className="client-header-logo"/>
          </a>
      </div>;
    } 
  } 

  componentDidMount () {
    document.title = globals.clientTitle + 'Dashboard';
  }  

  render() {
    const { signOut, location, authData, showModal } = this.props;

    const checkHomeRoute = location.pathname === "/";

    const checkClientLogo = ""; // prev option "dark-header";

    const { shutdown } = this.state

    if (shutdown) {         
      return <Route path="/" component={RedirectStateScapeLegacyLogout} /> 
    } else {
      return (
        <React.Fragment> 
        <header className={`client-header ${checkClientLogo}`}>
          <div className="d-flex client-header-layout-wrap pr-1">
            <a
              className="client-header-ss-logo"
              href={globals.corpUrl}
              target="_blank"
              rel="noreferrer noopener"
            >
              <img src={StatescapeLogo2} alt="logo" className="client-header-ss-logo"/>
            </a>
            <HeaderIcons
              location={location.pathname}
              onClick={this.signOutLegacy}
              showModal={showModal}
              authData={authData}
              checkHomeRoute={checkHomeRoute}
            />
          </div>
        </header>      
        { this.ClientBanner(authData) }
        </React.Fragment>
      );
    }
  }

  static propTypes = {
    signOut: PropTypes.func,
    location: PropTypes.object,
    authData: PropTypes.object,
    permissions: PropTypes.array,
    showModal: PropTypes.func,
  };
}

export default ClientHeader;



// WEBPACK FOOTER //
// ./src/components/Header/components/ClientSide/ClientHeader.js